import MainTable from "../../../components/mainpage/mainTable";
import {connect} from "react-redux";
import {fetchResultByType, resultSocket} from "../../../redux/actions/resultActions";
import {withTranslation} from "react-i18next";
import React from "react";
import BodyMt from "../../../components/results/mt/bodyMt";

const ResultMTPage = ({...props}) => {
    return (
        <MainTable>
            <BodyMt type="mt" {...props}/>
        </MainTable>
    )
};
const mapStateToProps = state => ({
    historyResult: state.resultMt.result,
    drawResult: state.resultMt.draw
});



export default connect(
    mapStateToProps,
    {
        fetchResultByType,
        resultSocket
    }
)(withTranslation()(ResultMTPage));
